<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="23"></FHeader>
		<FOtherBanner :name1="'关于我们'" :name2="'About Us'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article style="height: 1200px;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }" style="cursor: pointer;">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="cursor: default;">关于我们</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black;cursor: default;">发展历程</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;position: absolute;">
				<div style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">发展历程</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Development History</div>
				</div>
				<div style="width: 100%;text-align: center;">
					<img style="width:65%" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/pcHistory2.png">
				<!-- <div class="timelineBox">
					
            <el-timeline ref="timeline">
                <el-timeline-item v-for="(item, index) in versionAnnouncementList" :key="index" color="#CCCCCC">
                    <div v-if="index%2==0" class="evenDiv">
                        <div class="timelinItemBox0">
                            <div class="timelinItemBox-top f-r a-c" :style="{color:index%2==0?'#A6A6A6':'#ffffff','text-align':'right'}">
                                <div>
																	<div style="float: right;width: 40px;height: 0px;border: 1px dashed rgb(204, 204, 204);margin-top: 8px;margin-right: -30px;"></div>
																	<div style="float:right;margin-right:20px">{{item.releaseTime}}</div></div>
                            </div>
                            <div class="timelinItemBox-bottom" :style="{color:index%2==0?'#7F7F7F':'#ffffff','text-align':'right','margin-right': '32px'}">
                                <div v-for="(item2,index2) in item.list" :key="index2+item2">
																	<div>
																		<span style="width: 4px;display: inline-block;height: 4px;margin-bottom: 3px;margin-right: 7px;background: #7F7F7F;"></span>
																		<span>{{item2}}</span>
																	</div>
																</div>
                            </div>
                        </div>
                        <div class="timelinItemBox1">
                            <div class="timelinItemBox-top f-r a-c">
                                <div>{{item.releaseTime}}</div>
                            </div>
                            <div class="timelinItemBox-bottom">
                                {{item.content}}
                            </div>
                        </div>
                    </div>
                    <div v-else class="unevenDiv">
                        <div class="timelinItemBox0">
                            <div class="timelinItemBox-top f-r a-c">
                                <div>{{item.releaseTime}}</div>
                            </div>
                            <div class="timelinItemBox-bottom">
                                {{item.content}}
                            </div>
                        </div>
                        <div class="timelinItemBox1">
                            <div class="timelinItemBox-top f-r a-c" :style="{color:index%2!=0?'#A6A6A6':'#ffffff','text-align':'left'}">
																<div style="float: left;width: 40px;height: 0px;border: 1px dashed rgb(204, 204, 204);margin-top: 8px;margin-left: -30px;"></div>
                                <div style="float:left;margin-left:20px">{{item.releaseTime}}</div>
                            </div>
                            <div class="timelinItemBox-bottom" :style="{color:index%2!=0?'#A6A6A6':'#ffffff','text-align':'left','margin-left': '28px'}">
                                <div v-for="(item2,index2) in item.list" :key="index2+item2">
																	<div style="width: 260px;min-height: 50px;">
																		<span style="display: block;float: left;width: 250px;">{{item2}}</span>
																		<span style="width: 4px;display: block;float: right;height: 4px;margin-bottom: 3px;margin-top: 8px;background: rgb(127, 127, 127);"></span>
																	</div>
																</div>
                            </div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
        </div> -->
				</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {queryScenicList,querySoftwareList,queryArticleList} from "@/api/front";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				totalWidth:document.documentElement.clientWidth,
				left:46,
				versionAnnouncementList: [
                {		
                    uuid: "20230314_1053_5398371131177979",
										list:['上海和华利盛律师事务所成立'],
                    releaseTime: "2001-04-18",
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['多次获著名法律杂志The Asia Pacific Legal 500（亚太法律500强）重点推荐'],
                    releaseTime: "2004年开始",
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['测试1234查Referer','测试1234查Referer','测试1234查Referer','测试1234查Referer'],
                    content: "测试1234",
                    version: "V3.1",
                    releaseTime: "2023-10-28",
                    createTime: "2023-03-14 10:53:49",
                    updateTime: "2023-03-14 15:01:13",
                    color: '#21A0AD'
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['测试1234查Referer','测试1234查Referer','测试1234查Referer','测试1234查Referer'],
                    content: "测试1234",
                    version: "V3.1",
                    releaseTime: "2023-10-28",
                    createTime: "2023-03-14 10:53:49",
                    updateTime: "2023-03-14 15:01:13",
                    color: '#507CBE'
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['测试1234查Referer','测试1234查Referer','测试1234查Referer','测试1234查Referer'],
                    content: "测试1234",
                    version: "V3.1",
                    releaseTime: "2023-10-28",
                    createTime: "2023-03-14 10:53:49",
                    updateTime: "2023-03-14 15:01:13",
                    color: '#21A0AD'
                },
                
            ],
			}
		},
		mounted() {
			window.onresize = () => {
				return (() => {
					this.totalWidth = document.documentElement.clientWidth
				})()
			}
			this.left = (this.totalWidth>1000?((((this.totalWidth-1000)/6)*0.01)+46):(46-(((1000-this.totalWidth)/6)*0.01)))
			this.changeLeft()
			console.log(this.totalWidth)
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
			screenWidth: {
				handler: function (val) {
					this.left = (this.totalWidth>1000?((((this.totalWidth-1000)/6)*0.01)+46):(46-(((1000-this.totalWidth)/6)*0.01)))
					this.changeLeft()
				},
				immediate: true,
				deep:true
			},
		},
		methods: {
			changeLeft(){
				document.getElementsByClassName('timelineBox')[0].style.left=this.left+'%'
				// this.$refs.mycolor.style.setProperty("--bgc",'white');
			}
			
		}
	}
</script>
<style lang='less'>


	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
// 通用样式 start
.h-100{
    height: 100%;
}
.p-r{
    position: relative;
}
.f-r {
    // display: flex;
    flex-direction: row;
}
.a-c {
    align-content: center;
    align-items: center;
}
.m-l20 {
    margin-left: 20px;
}
// 通用样式 end

.timelineBox {
    position: absolute;
    left: 50%;
    top:85%;
    width: 40%;
    .el-timeline-item{
        padding-bottom: 5px;
    }
}
.timelinItemBox0 {
    width: calc(100% - 28px - 2px);
    height: calc(100% - 2px);
    position: absolute;
    right: calc(100% + 18px);
    // border: 1px solid #dedede;
    border-radius: 5px;
}
.timelinItemBox1{
    height: calc(100% - 2px);
    // border: 1px solid #dedede;
    border-radius: 5px;
}
.timelinItemBox-top{
    height: 35px;
    padding: 0 10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: #ffffff;
}
.timelinItemBox-bottom{
    padding: 10px;
    color: #606266;
    line-height: 20px;
    white-space: pre-wrap;
}
.evenDiv{
    .timelinItemBox1{
        border: 1px solid #ffffff;
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        .timelinItemBox-bottom{
            color: #ffffff;
        }
    }
}
.unevenDiv{
    .timelinItemBox0{
        border: 1px solid #ffffff;
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        .timelinItemBox-bottom{
            color: #ffffff;
        }
    }
}
</style>
<style lang="scss" scoped>
	.main-containter {
		min-width: 1000px;
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
</style>
<style lang="scss" scoped="scoped">
	.middle{
		background: url('https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/adoutUsMiddle.png') no-repeat;
		background-size:100% 100%;
		width: 100%;
		height: 300px;
		margin-bottom: 70px;
		margin-top: 100px;
	}
	.aboutContent{
		width: 64%;
		padding: 30px 18%;
		padding-top: 50px;
		display: flex;
		flex-direction: row;
		// justify-content: space-between;
		.left{
			width: 61%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			.cmpName{
				width: 100%;
				height: 50px;
				font-size: 28px;
				font-family: Adobe Heiti Std R;
				color: #2E2E2E;
				line-height: 33px;
				border-bottom: 2px solid #469DFF;
			}
			.cmpInfo{
				width: 600px;
				padding: 10px 0;
				font-size: 21px;
				font-family: Adobe Heiti Std R;
				color: #838383;
				line-height: 33px;
			}
			.button{
				width: 120px;
				height: 36px;
				color: #FFFFFF;
				font-size: 16px;
				line-height: 36px;
				text-align: center;
				border-radius: 20px;
				background-color: #1A86FF;
				cursor: pointer;
				margin-top: 20px;
			}
		}
		.right{
		padding-left: 7%;
    height: 100%;
		}
	}
</style>
